import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class EmojiConfigService {
    readonly i18n = {
        search: this.translateService.instant('Search'),
        emojilist: this.translateService.instant('List of emoji'),
        notfound: this.translateService.instant('No Emoji Found'),
        clear: this.translateService.instant('Clear'),
        categories: {
            search: this.translateService.instant('Search Results'),
            recent: this.translateService.instant('Frequently Used'),
            people: this.translateService.instant('Smileys & People'),
            nature: this.translateService.instant('Animals & Nature'),
            foods: this.translateService.instant('Food & Drink'),
            activity: this.translateService.instant('Activity'),
            places: this.translateService.instant('Travel & Places'),
            objects: this.translateService.instant('Objects'),
            symbols: this.translateService.instant('Symbols'),
            flags: this.translateService.instant('Flags'),
            custom: this.translateService.instant('Custom'),
        },
        skintones: {
            1: this.translateService.instant('Default Skin Tone'),
            2: this.translateService.instant('Light Skin Tone'),
            3: this.translateService.instant('Medium-Light Skin Tone'),
            4: this.translateService.instant('Medium Skin Tone'),
            5: this.translateService.instant('Medium-Dark Skin Tone'),
            6: this.translateService.instant('Dark Skin Tone'),
        },
    };

    constructor(private translateService: TranslateService) {}
}
